import { Chart } from "chart.js";

/* =========================
   Helpers
========================= */
function calculateNiceMax(values) {
  const rawMax = Math.max(...values, 0);
  if (rawMax === 0) return 100;

  const maxWithMargin = Math.ceil(rawMax + rawMax * 0.1);
  const magnitude = Math.pow(10, Math.floor(Math.log10(maxWithMargin)));
  return Math.ceil(maxWithMargin / magnitude) * magnitude;
}

/* =========================
   SALES: BY CATEGORY
========================= */
export function salesByCategory(ctx, salesReportData, palette) {
  if (!salesReportData?.labels || !salesReportData?.series) return null;

  const { labels, series } = salesReportData;

  const datasets = Object.keys(series).map((key, i) => ({
    label: key,
    data: series[key],
    borderColor: palette[i % palette.length],
    backgroundColor: palette[i % palette.length],
    tension: 0.25,
    fill: false,
    pointRadius: 3,
    _solidColor: palette[i % palette.length],
  }));

  const niceMax = calculateNiceMax(
    datasets.flatMap((d) => d.data)
  );

  return new Chart(ctx, {
    type: "line",
    data: { labels, datasets },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { position: "top", align: "end" },
        tooltip: { mode: "index", intersect: false },
      },
      scales: {
        y: {
          beginAtZero: true,
          max: niceMax,
          ticks: { callback: (v) => v.toLocaleString("en-IN") },
        },
      },
    },
  });
}

/* =========================
   SALES: BY DIVISION
========================= */
export function salesByDivision(ctx, salesDivisionData, palette) {
  if (!salesDivisionData?.labels || !salesDivisionData?.series) return null;

  const { labels, series } = salesDivisionData;

  const datasets = Object.keys(series).map((key, i) => ({
    label: key,
    data: series[key],
    borderColor: palette[i % palette.length],
    backgroundColor: palette[i % palette.length],
    tension: 0.25,
    fill: false,
    pointRadius: 3,
    _solidColor: palette[i % palette.length],
  }));

  const niceMax = calculateNiceMax(
    datasets.flatMap((d) => d.data)
  );

  return new Chart(ctx, {
    type: "line",
    data: { labels, datasets },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { position: "top", align: "end" },
        tooltip: { mode: "index", intersect: false },
      },
      scales: {
        y: {
          beginAtZero: true,
          max: niceMax,
          ticks: { callback: (v) => v.toLocaleString("en-IN") },
        },
      },
    },
  });
}
